export default __webpack_public_path__ + "static/bb-05236c9223525e4080f168af5c37d7ec.png";